// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/icons/marevo-icon-close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sum__page #js-summary-image-preview-1 {
  height: 30dvh;
}

#summary-content {
  position: absolute;
  width: 100%;
  background-color: rgba(26, 26, 26, 0.3019607843);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 36px 30px;
  height: 100%;
  top: 0;
}

.color-option {
  color: #629A33 !important;
}

.title_margin {
  margin-top: 6px;
}

.title_data {
  color: #629A33;
}

.sum__page {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 30px;
  border: 1px solid rgba(98, 154, 51, 0.3);
  background-color: #ffffff;
  max-width: 535px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.sum__page__title {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  color: #629A33;
}
.sum__page__close {
  cursor: pointer;
  display: flex;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 16px;
  right: 16px;
  transition: all 0.3s;
}
.sum__page__close:hover {
  transform: rotate(180deg);
}
.sum__page__close::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sum__page__main-list {
  width: 100%;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;
  margin-top: 10px;
}
.sum__page__main-list__title {
  text-align: center;
  font-family: "Inter", serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  border-bottom: 0.5px solid rgba(98, 154, 51, 0.3);
  padding-bottom: 10px;
  margin-bottom: 10px;
  color: #1A1A1A;
}
.sum__page__main-list__info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.sum__page__main-list__info__title {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
}
.sum__page__main-list__info__title--el {
  padding: 20px 0;
}
.sum__page__main-list__info__param {
  font-family: "Inter", serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #629A33;
}
.sum__page__main-list__info__color {
  width: 40px;
  height: 20px;
  border: 0.5px solid #629A33;
}
.sum__page__main-list__item {
  display: block;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
}
.sum__page__main-list__item--lil {
  border: none;
  padding: 0 0 12px 0;
}
.sum__page__main-list__item--lil--color {
  color: #629A33;
  margin: 5px 0;
}
.sum__page__main_description {
  margin-block-start: 10px;
  margin-block-end: 10px;
  color: #629A33;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
}
.sum__page__electrical-options {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.sum__page__buttons {
  gap: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.sum__page__buttons__button {
  cursor: pointer;
  width: 147px;
  height: 50px;
  flex: 1;
  padding: 12px;
  outline: 0;
  border: 1px solid #629A33;
  background-color: #629A33;
  color: #ffffff;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: center;
  transition: all 0.3s;
  text-transform: uppercase;
}
.sum__page__buttons__button--back {
  border: 1px solid #629A33;
  background-color: #ffffff;
  color: #629A33;
  padding: 12px 20px;
  transition: all 0.3s ease;
  font-size: 13px !important;
}
.sum__page__buttons__button--back:hover {
  background-color: #629A33 !important;
  color: #ffffff !important;
  transform: translateY(-3px);
}
.sum__page__buttons__button--contact {
  font-size: 13px !important;
}
.sum__page__buttons__button:hover {
  background-color: #1A1A1A;
  color: #ffffff;
  transform: translateY(-3px);
}
.sum__page__img {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/summary/summary-page/summaryPage.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;AAFD;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,gDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,cCzBa;ADuBf;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;EACA,yBC7BY;ED8BZ,gBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,sBAAA;AAHF;AAKE;EEnCC,2BAAA;EFqCC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cCnDW;ADgDf;AAME;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;AAJJ;AAMI;EACE,yBAAA;AAJN;AAOI;EACE,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALN;AASE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAPJ;AASI;EACE,kBAAA;EEpFH,2BAAA;EFsFG,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,cCnGS;AD4Ff;AAUI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AARN;AAUM;EE3GJ,2BAAA;EF6GM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AARR;AAUQ;EACE,eAAA;AARV;AAgBM;EE3HJ,2BAAA;EF6HM,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCrIO;ADuHf;AAiBM;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AAfR;AAmBI;EACE,cAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;AAjBN;AAmBM;EACE,YAAA;EACA,mBAAA;AAjBR;AAmBQ;EACE,cC1JK;ED2JL,aAAA;AAjBV;AAuBE;EACE,wBAAA;EACA,sBAAA;EACA,cCpKW;EDqKX,gBAAA;EACA,eAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,yBClMS;EDmMT,cC9LQ;ECqCZ,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EFqJI,kBAAA;EACA,oBAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,yBAAA;EACA,yBCtMM;EDuMN,cC5MO;ED6MP,kBAAA;EACA,yBAAA;EACA,0BAAA;AAjBR;AAmBQ;EACE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAjBV;AAqBM;EACE,0BAAA;AAnBR;AAsBM;EACE,yBC1NO;ED2NP,cCzNM;ED0NN,2BAAA;AApBR;AAyBE;EACE,WAAA;EACA,YAAA;AAvBJ","sourcesContent":["@use \"../../../styles/mixins\" as mixins;\n@use \"../../../styles/variables\" as vars;\n\n.sum__page #js-summary-image-preview-1 {\n height: 30dvh;\n}\n\n#summary-content {\n  position: absolute;\n  width: 100%;\n  background-color: #1A1A1A4D;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 36px 30px;\n  height: 100%;\n  top: 0;\n}\n\n.color-option {\n  color: vars.$second-color !important;\n}\n\n.title_margin {\n  margin-top: 6px;\n}\n\n.title_data {\n  color: vars.$second-color;\n}\n\n.sum__page {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  padding: 30px;\n  border: 1px solid rgba($color: vars.$second-color, $alpha: 0.3);\n  background-color: vars.$white-color;\n  max-width: 535px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  &__title {\n    @include mixins.font-family-second();\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    vertical-align: bottom;\n    text-transform: uppercase;\n    color: vars.$second-color;\n  }\n\n  &__close {\n    cursor: pointer;\n    display: flex;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    transition: all 0.3s;\n\n    &:hover {\n      transform: rotate(180deg);\n    }\n\n    &::after {\n      content: \"\";\n      background-image: url(/public/img/icons/marevo-icon-close.svg);\n      background-position: center;\n      background-repeat: no-repeat;\n      width: 20px;\n      height: 20px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  &__main-list {\n    width: 100%;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 14px;\n    margin-top: 10px;\n\n    &__title {\n      text-align: center;\n      @include mixins.font-family-second();\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      text-transform: uppercase;\n      border-bottom: 0.5px solid rgba($color: vars.$second-color, $alpha: 0.3);\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n      color: vars.$black-color;\n    }\n\n    &__info {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 5px;\n\n      &__title {\n        @include mixins.font-family();\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 120%;\n        letter-spacing: 0%;\n\n        &--el {\n          padding: 20px 0;\n        }\n\n        // &--lil {\n        //   @include mixins.h4();\n        // }\n      }\n\n      &__param {\n        @include mixins.font-family();\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 120%;\n        letter-spacing: 0%;\n        color: vars.$second-color;\n      }\n\n      &__color {\n        width: 40px;\n        height: 20px;\n        border: 0.5px solid vars.$second-color;\n      }\n    }\n\n    &__item {\n      display: block;\n      gap: 10px;\n      justify-content: space-between;\n      width: 100%;\n\n      &--lil {\n        border: none;\n        padding: 0 0 12px 0;\n\n        &--color {\n          color: vars.$second-color;\n          margin: 5px 0;\n        }\n      }\n    }\n  }\n\n  &__main_description {\n    margin-block-start: 10px;\n    margin-block-end: 10px;\n    color: vars.$second-color;\n    font-weight: 400;\n    font-size: 14px;\n    text-align: center;\n  }\n\n  &__electrical-options {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  &__buttons {\n    gap: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 50px;\n\n    &__button {\n      cursor: pointer;\n      width: 147px;\n      height: 50px;\n      flex: 1;\n      padding: 12px;\n      outline: 0;\n      border: 1px solid vars.$second-color;\n      background-color: vars.$second-color;\n      color: vars.$white-color;\n      @include mixins.h4();\n      text-align: center;\n      transition: all 0.3s;\n      text-transform: uppercase;\n\n      &--back {\n        border: 1px solid vars.$second-color;\n        background-color: vars.$white-color;\n        color: vars.$second-color;\n        padding: 12px 20px;\n        transition: all 0.3s ease;\n        font-size: 13px !important;\n\n        &:hover {\n          background-color: vars.$second-color !important;\n          color: vars.$white-color !important;\n          transform: translateY(-3px);\n        }\n      }\n\n      &--contact {\n        font-size: 13px !important;\n      }\n\n      &:hover {\n        background-color: vars.$black-color;\n        color: vars.$white-color;\n        transform: translateY(-3px);\n      }\n    }\n  }\n\n  &__img {\n    width: 100%;\n    height: 100%;\n    // filter: grayscale(100%);\n  }\n\n}","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
